<template>
  <div class="p-form-code">
    <div class="p-form-code__inputs">
      <InputCode
        v-model="code1"
        id="code1"
        name="code1"
        class="p-form-code__input"
        @keypress="keypressed(2)"
        @input="updateValue(2)"
      ></InputCode>
      <InputCode
        v-model="code2"
        name="code2"
        ref="code2"
        class="p-form-code__input"
        @keypress="keypressed(3)"
        @input="updateValue(3)"
      ></InputCode>
      <InputCode
        v-model="code3"
        name="code3"
        ref="code3"
        class="p-form-code__input"
        @keypress="keypressed(4)"
        @input="updateValue(4)"
      ></InputCode>
      <InputCode
        v-model="code4"
        name="code4"
        ref="code4"
        class="p-form-code__input"
        @input="updateValue(0)"
      ></InputCode>
    </div>
    <div class="p-form-code__slot">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import InputCode from "@/common/components/atoms/InputCode.vue";
import { Options, Vue } from 'vue-class-component';
import LocalStorage from "@/general/utils/storage";

@Options({
  props: {
    code: { type: Object, required: false }
  },
  components: { InputCode }
})
export default class FormCode extends Vue {
  code!: any;

  code1 = "";
  code2 = "";
  code3 = "";
  code4 = "";

  keypressed(codeNumber: any) {
    if (codeNumber) {
      (this.$refs[`code${codeNumber}`] as any).selfFocus();
    }
  }
  updateValue(codeNumber: any) {
    const code = this.code1 + this.code2 + this.code3 + this.code4;
    this.$emit("set", code);
  }

  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (
      urlParams.get("back_from") &&
      urlParams.get("back_from") == "email_confirmation"
    ) {
      const code = LocalStorage.getItem("code")
        ? (LocalStorage.getItem("code") as string)
        : "";

      const codeArr = code.split("");
      this.code1 = codeArr[0];
      this.code2 = codeArr[1];
      this.code3 = codeArr[2];
      this.code4 = codeArr[3];
      this.$emit("set", code);
    }
  }
}
</script>

<style lang="scss" scoped>
.p-form-code {
  &__inputs {
    display: flex;
  }

  &__input {
    width: rem(48);

    & + & {
      margin-left: rem(8);
    }
  }

  &__slot {
    margin-top: rem(8);
  }
}
</style>
